
export const preloadedValues = {
  prOFRecStatus: false,
  prOFMod:  "",
  prOFOperId: "",
  prOFProposito:  "",
};
